export var ApplicationName;
(function (ApplicationName) {
    ApplicationName["EXPLORER"] = "explorer";
    ApplicationName["PROFILE"] = "profile";
    ApplicationName["BUILDER"] = "builder";
    ApplicationName["MARKETPLACE"] = "marketplace";
    ApplicationName["ACCOUNT"] = "account";
    ApplicationName["DAO"] = "dao";
    ApplicationName["EVENTS"] = "events";
    ApplicationName["LANDING"] = "landing";
    ApplicationName["DAPPS"] = "dapps";
    ApplicationName["TEST"] = "test";
})(ApplicationName || (ApplicationName = {}));
// Make sure that in order to handle these, the client has to fetch ApplicationName.DAPPS feature flags.
export var FeatureName;
(function (FeatureName) {
    FeatureName["MAGIC_AUTO_SIGN"] = "magic-auto-sign";
})(FeatureName || (FeatureName = {}));
//# sourceMappingURL=types.js.map